import React from "react";
import { Section, SectionHeading } from "./_shared";
import SkillsMarquee from "../SkillsMarquee";
import { resolveIcon } from "../../lib/iconResolver";

const SKILL_COLORS = {
  Java: "#007396",
  SQL: "#4479A1",
  JavaScript: "#F7DF1E",
  TypeScript: "#3178C6",
  HTML5: "#E34F26",
  CSS3: "#1572B6",
  Angular: "#DD0031",

  "Spring Boot": "#6DB33F",
  "Spring MVC": "#6DB33F",
  "Spring Data JPA": "#6DB33F",
  Hibernate: "#59666C",
  "Spring Security": "#6DB33F",
  Microservices: "#8B5CF6",
  "RESTful APIs": "#22D3EE",
  "JWT Authentication": "#FB015B",

  Oracle: "#F80000",
  MySQL: "#4479A1",
  MongoDB: "#47A248",

  Docker: "#2496ED",
  Kubernetes: "#326CE5",
  "AWS (EC2)": "#FF9900",
  Jenkins: "#D24939",

  Maven: "#C71A36",
  Gradle: "#02303A",
  JUnit: "#25A162",
  Postman: "#FF6C37",
  "Swagger (OpenAPI)": "#85EA2D",
  Git: "#F05032",
  GitHub: "#E5E7EB",
  SonarQube: "#4E9BCD",
};

/**
 * Build rows from database skills.
 */
function buildRows(items) {
  const groups = {};

  items.forEach((skill) => {
    if (!groups[skill.category]) {
      groups[skill.category] = [];
    }

    groups[skill.category].push(skill);
  });

  Object.values(groups).forEach((skills) => {
    skills.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  });

  const preferred = [
    ["Languages", "Frontend"],
    ["AI / ML"],
    [
      "Backend",
      "Databases",
      "Data",
      "Tools",
      "Cloud",
      "DevOps",
    ],
  ];

  const rows = preferred
    .map((categories) =>
      categories.flatMap((category) => groups[category] || [])
    )
    .filter((row) => row.length > 0);

  if (rows.length === 0) {
    const allSkills = items
      .slice()
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    const fallbackRows = [[], [], []];

    allSkills.forEach((skill, index) => {
      fallbackRows[index % 3].push(skill);
    });

    return fallbackRows.filter((row) => row.length > 0);
  }

  return rows;
}

function mapItem(skill) {
  return {
    name: skill.name,
    Icon: resolveIcon(skill.iconKey || skill.name),
    color:
      SKILL_COLORS[skill.name] ||
      skill.color ||
      "#00F0FF",
  };
}

const Skills = ({ items = [] }) => {
  const rows = buildRows(items).map((row) => row.map(mapItem));

  return (
    <Section id="skills">
      <SectionHeading
        index="04"
        label="Skills"
        title="Stack & toolkit."
        description="Technologies I use to build AI systems, intelligent applications, and modern software."
        testId="skills-heading"
      />

      {rows.length > 0 ? (
        <SkillsMarquee rows={rows} />
      ) : (
        <div className="text-slate-500 text-sm">
          No skills yet — add them from the admin panel.
        </div>
      )}
    </Section>
  );
};

export default Skills;